import { MutationOptions, useMutation } from "@tanstack/react-query";
import { isInvalidCredential, useSignOut } from "@newHooks/auth/useSignOut";
import { RestUrl } from "@maven-rest/common/cyan.types";
import { HttpRequest, RestError } from "@maven-rest/common/HttpRequest";

type BaseMutationOptions<TData, TVariables> = {
  fnOption?: {
    host?: string;
    url: RestUrl;
    query?: Record<string, string>;
  };
} & MutationOptions<TData, RestError, TVariables>;

export type SimpleMutationOptions<TData, TVariables = undefined> = BaseMutationOptions<TData, TVariables>;

export const useBaseMutation = <TData, TVariables = undefined>({
  fnOption,
  ...mutationOptions
}: BaseMutationOptions<TData, TVariables>) => {
  const signOut = useSignOut();
  const mutation = useMutation<TData, RestError, TVariables>({
    mutationFn: fnOption?.url
      ? async (variables?: TVariables) => {
          const resp = await HttpRequest.request<TData>(
            fnOption.host || process.env.REACT_APP_DOCS_BE_URL || "",
            fnOption.url?.[0] || "POST",
            fnOption.url?.[1] || "",
            variables,
            {}
          );
          return resp.data;
        }
      : mutationOptions.mutationFn,
    ...mutationOptions,
    onError: (error, variables, context) => {
      if (isInvalidCredential(error)) {
        signOut();
      }

      if (mutationOptions.onError) {
        mutationOptions.onError(error, variables, context);
      }
    },
  });
  return mutation;
};
